import { useCallback, useEffect, useState } from 'react';
import PageTemplate from 'components/template/PageTemplate';
import Container from 'components/common/Container';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { jsonAxios } from 'components/axios';
import { ReactComponent as Light } from 'assets/news/light.svg'
import { ReactTyped } from "react-typed";
import { toast } from 'react-toastify';

const NewsDetail = () => {
    interface IData {
        id: number,
        title: string,
        transportType: string,
        thumbnail: string,
        createAt: string
        aiSummary: string
        content: string
        region: string
    }

    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const id = searchParams.get('id');
    const [data, setData] = useState<IData>({} as IData);

    const init = useCallback(() => {
        if (!id) {
            toast.error('잘못된 경로입니다.');
            setTimeout(() => {
                navigate(-1);
            }, 500);
            return;
        }
        jsonAxios.get(`articles/${id}`).then(res => {
            if (res.data.code == 200) {
                setData(res.data.data)
            }
        })
    }, [id])

    useEffect(() => {
        init()
    }, [init])

    return (
        <PageTemplate background='bg-[#F8F8FA]'>
            <Container className="flex flex-col gap-10 tablet:gap-4 mb-6 pt-21 tablet:pt-6 h-full min-h-dvh">
                <div className='flex flex-col gap-3'>
                    <p className='font-semibold text-3xl'>펄스온쉽 물류뉴스</p>
                    <p className='text-lg'>글로벌 공급망 관련 물류 이슈와 뉴스를 확인해보세요</p>
                </div>

                <div className='bg-white rounded-lg'>
                    <div className='flex tablet:flex-col justify-between items-center px-10 py-6 border-[#F8F8FA] border-b-2'>
                        <div className='flex tablet:flex-col items-center gap-6'>
                            <p className='font-semibold tablet:text-xl text-2xl'>{data.title}</p>
                        </div>
                        <p className='text-lg'>{data.createAt}</p>
                    </div>
                    <div className='flex flex-col gap-10 px-10 py-6'>
                        {
                            data.thumbnail &&
                            <div className='flex justify-center items-center'>
                                <img
                                    className='object-contain'
                                    src={data.thumbnail}
                                    alt="thumbnail"
                                />
                            </div>
                        }

                        {
                            data?.aiSummary &&
                            <div className='bg-[#F8F8FA] p-10'>
                                <div className='flex justify-start items-center gap-2 mb-10'>
                                    <Light />
                                    <p className='font-semibold text-primary text-2xl'>솔로몬쉽 AI 뉴스 요약</p>
                                </div>
                                <p>
                                    <ReactTyped
                                        strings={[data?.aiSummary]}
                                        typeSpeed={5}
                                        showCursor={false}
                                        onComplete={() => {
                                            // handleComplete()
                                        }}
                                    />
                                </p>
                            </div>
                        }
                        <div dangerouslySetInnerHTML={{ __html: data.content }}></div>
                    </div>
                </div>
            </Container>
        </PageTemplate>
    )
}

export default NewsDetail